
import React from 'react';
import { ChevronDown } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface ScrollToBottomButtonProps {
  onClick: () => void;
  show: boolean;
}

const ScrollToBottomButton: React.FC<ScrollToBottomButtonProps> = ({ onClick, show }) => {
  if (!show) return null;

  return (
    <div className="absolute bottom-20 right-4 z-10">
      <Button
        onClick={onClick}
        size="sm"
        className="rounded-full h-10 w-10 p-0 bg-blue-500 hover:bg-blue-600 text-white shadow-lg animate-in fade-in-0 slide-in-from-bottom-2"
        title="Scroll to bottom"
      >
        <ChevronDown className="h-4 w-4" />
      </Button>
    </div>
  );
};

export default ScrollToBottomButton;
